import React, { useState } from 'react';
import './Header.css';
import { getPropelWhoAmI, logoutFromPropel } from '../services/apiService';

const Header = ({ userName, isPropelAuthenticated, documentId, workspaceId }) => {
  const [showPropelInfo, setShowPropelInfo] = useState(false);
  const [whoAmI, setWhoAmI] = useState(null);
  const [loadingWhoAmI, setLoadingWhoAmI] = useState(false);
  const [whoAmIError, setWhoAmIError] = useState('');
  const [loggingOut, setLoggingOut] = useState(false);

  const openPropelInfo = async () => {
    if (!isPropelAuthenticated) return;
    setShowPropelInfo(true);
    setLoadingWhoAmI(true);
    setWhoAmIError('');
    try {
      const info = await getPropelWhoAmI();
      setWhoAmI(info);
    } catch (e) {
      setWhoAmIError(e?.message || 'Failed to fetch Propel identity');
    } finally {
      setLoadingWhoAmI(false);
    }
  };

  const closePropelInfo = () => {
    setShowPropelInfo(false);
  };

  const handleLogout = async () => {
    if (!window.confirm('Are you sure you want to logout from Propel? You will need to authenticate again.')) {
      return;
    }
    
    setLoggingOut(true);
    try {
      const success = await logoutFromPropel();
      if (success) {
        // Reload the page to trigger re-authentication flow
        window.location.reload();
      } else {
        alert('Failed to logout from Propel. Please try again.');
      }
    } catch (error) {
      console.error('Error during logout:', error);
      alert('An error occurred during logout. Please try again.');
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <div className="header compact-header">
      <div className="header-left">
        <img src={require('../assets/propel-logo-darkbg.png')} alt="Propel Logo" className="header-logo" />
      </div>
      <div className="header-right">
        {userName && (
          <div className="user-info compact-user-info">
            <button
              className={`propel-info-icon ${isPropelAuthenticated ? '' : 'disabled'}`}
              disabled={!isPropelAuthenticated}
              title={isPropelAuthenticated ? 'Show connection details' : 'Authenticate with Propel to view details'}
              onClick={openPropelInfo}
              aria-label="Propel connection info"
            >
              i
            </button>
          </div>
        )}
      </div>

      {showPropelInfo && (
        <div className="modal-overlay" onClick={closePropelInfo}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Propel Connection</h3>
              <button className="modal-close" onClick={closePropelInfo} aria-label="Close">×</button>
            </div>
            <div className="modal-body">
              <div style={{ marginBottom: '12px' }}>
                <strong>Authentication</strong>
                <div style={{ display: 'flex', gap: '16px', marginTop: '8px' }}>
                  <div className="status-indicator">
                    <span className="status-label">Onshape:</span>
                    <span className="status-dot authenticated"></span>
                  </div>
                  <div className="status-indicator">
                    <span className="status-label">Propel:</span>
                    <span className={`status-dot ${isPropelAuthenticated ? 'authenticated' : 'not-authenticated'}`}></span>
                  </div>
                </div>
              </div>
              {loadingWhoAmI && (<div>Loading...</div>)}
              {whoAmIError && (<div className="error">{whoAmIError}</div>)}
              {whoAmI && (
                <div className="propel-info-grid">
                  <div><strong>Org URL:</strong></div>
                  <div><a href={whoAmI.instanceUrl} target="_blank" rel="noreferrer">{whoAmI.instanceUrl}</a></div>
                  <div><strong>User:</strong></div>
                  <div>{whoAmI.displayName || whoAmI.username}</div>
                  <div><strong>User ID:</strong></div>
                  <div>{whoAmI.userId}</div>
                  <div><strong>Org ID:</strong></div>
                  <div>{whoAmI.organizationId}</div>
                </div>
              )}
              {isPropelAuthenticated && (
                <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #e0e0e0', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                  <button
                    onClick={() => {
                      const params = new URLSearchParams();
                      if (documentId) params.set('documentId', documentId);
                      if (workspaceId) params.set('workspaceId', workspaceId);
                      const qs = params.toString();
                      window.open(`/backfill${qs ? `?${qs}` : ''}`, '_blank', 'noopener,noreferrer');
                    }}
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#0066cc',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '500'
                    }}
                  >
                    Backfill Propel IDs ↗
                  </button>
                  <button
                    onClick={handleLogout}
                    disabled={loggingOut}
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#dc3545',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: loggingOut ? 'not-allowed' : 'pointer',
                      opacity: loggingOut ? 0.6 : 1,
                      fontSize: '14px',
                      fontWeight: '500'
                    }}
                  >
                    {loggingOut ? 'Logging out...' : 'Logout from Propel'}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
